import {BaseService} from "./BaseService";
import {MaintenanceHistory} from "../entities/MaintenanceHistory";
import { StateService } from "@uirouter/angularjs";

export class MaintenanceHistoryService extends BaseService<MaintenanceHistory>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, MaintenanceHistory);
    }
    protected getBaseUrl():string{
        return "maintenancehistory";
    }
    protected getBasesUrl():string{
        return "maintenancehistories";
    }
    getByAsset(assetId:number):ng.IPromise<MaintenanceHistory[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"asset/"+assetId, config);
    }
}
